export default "__VITE_ASSET__92477b48__"